export default "__VITE_ASSET__28f75f32__"